import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { passwordValidator } from "src/app/shared/validators/password.validator";
import { MustMatch } from "src/app/shared/validators/passwordMatch";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  invokeUpdateUserPassword,
  resultUpdateUserPassword,
} from "src/app/store/user/user.actions";
import { resultUpdateUserPasswordSelector } from "src/app/store/user/user.selectors";

@Component({
  selector: "app-update-password",
  templateUrl: "./update-password.component.html",
})
export class UpdatePasswordComponent extends BaseComponent implements OnInit {
  form: FormGroup;
  @Input() companyName: string;
  @Input() email: string;
  @Output() closeTheModal: EventEmitter<boolean> = new EventEmitter();
  public showPassword: boolean = false;
  public showNewPassword: boolean = false;

  resultChangePassword$: Observable<SuccessDto | null>;
  loading : boolean = false
  constructor(
    private fb: FormBuilder,
    private saveHistory: SaveUserHistoryService,
    private store: Store<AppStateInterface>,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    super(store);
    this.resultChangePassword$ = this.store
      .pipe(select(resultUpdateUserPasswordSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.form = this.fb.group(
      {
        newPassword: [
          null,
          [
            Validators.required,
            passwordValidator(),
            Validators.minLength(8),
            Validators.maxLength(32),
          ],
        ],
        reNewPassword: [
          null,
          [
            Validators.required,
            passwordValidator(),
            Validators.minLength(8),
            Validators.maxLength(32),
          ],
        ],
      },
      {
        validator: MustMatch("newPassword", "reNewPassword"),
      }
    );
  }

  ngOnInit(): void {
    this.resultChangePassword$.subscribe((result) => {
      if (result) {
        this.loading = false
        this.toastr.success(
          this.translate.instant("response.success." + result.message),
          this.translate.instant("response.successTitle")
        );
        this.closeTheModal.emit(true)
      }
      this.store.dispatch(resultUpdateUserPassword({ successMessage: null }));
    });
  }

  clickShowPassword() {
    this.showPassword = !this.showPassword;
  }
  clickShowNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }

  close() {
    this.closeTheModal.emit(true);
  }

  update() {
    if (this.form.valid) {
      this.loading = true
      this.store.dispatch(
        invokeUpdateUserPassword({
          email: this.email,
          password: this.form.get("newPassword")?.value,
        })
      );

      this.saveHistory.saveUserHistory(
        UserHistoryActionsEnum.PATCH,
        UserHistoryServicesEnum.UPDATE_PASSWORD
      );
    }
  }
}
